/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TimeoutService {
  tiempoDeInactividad = +environment.sessionTimeOut * 60000;
  timer: any;

  constructor(private authService: MsalService) {}

  iniciarTimeOut(): void {
    this.resetearTimer();
    this.timer = setTimeout(() => {
      console.log('### LogOut por inactividad ###');
      this.logout();
    }, this.tiempoDeInactividad);
  }

  resetearTimer(): void {
    clearTimeout(this.timer);
  }

  logout(): void {
    this.authService.logoutRedirect();
  }
}
